// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"164":"terms","957":"privacy"}[chunkId] + "." + {"164":"9392d278","957":"26df5952"}[chunkId] + ".css";
};